import { render, staticRenderFns } from "./universal-modal.vue?vue&type=template&id=ff0bb7fe&scoped=true&"
import script from "./universal-modal.vue?vue&type=script&lang=js&"
export * from "./universal-modal.vue?vue&type=script&lang=js&"
import style0 from "./universal-modal.vue?vue&type=style&index=0&id=ff0bb7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0bb7fe",
  null
  
)

export default component.exports